import styled from './listaassistencias.module.css';
import api from '../../services/api';
import { useContext, useEffect, useState } from 'react';
import { CiFilter, CiSearch } from 'react-icons/ci';
import { Loader } from '../Loader';
import Pagination from 'react-paginate';
import '../../utils/pagination.css';
import { Alerta } from '../../utils/functions';
import { AuthContext } from '../../services/global';
import {useNavigate} from 'react-router-dom'

function Listaassistencias() {
    const login = JSON.parse(localStorage.getItem("login"));
    const cgccli = login.cgccli;
    const [filtersitua, setFiltersitua] = useState(false);
    const [fil1, setFil1] = useState('');
    const [fil2, setFil2] = useState('0');
    const [fil3, setFil3] = useState('Todos');
    const [tipfil, setTipfil] = useState('2');
    const [isLoading, setLoading] = useState(false);
    const [assistencias, SetAssistencias] = useState([]);
    const [datas, setDatas] = useState([]);
    const {dadosass,setDadosAss} = useContext(AuthContext);
    const Navigate = useNavigate('');

    const itemPerPage = 6;
    const [currentPage, setCurrentPage] = useState(0);

    //Logica para Paginação
    const pages = (Math.ceil(datas.length / itemPerPage));
    const startIndex = currentPage * itemPerPage;
    const endtIndex = startIndex + itemPerPage;

    const currentItens = (datas.slice(startIndex, endtIndex));

    const PageClick = (event) => {
        setCurrentPage(event.selected);
    };

    function Limpar() {
        setTipfil('2');
        setFil1('');
        setFil2('0');
        setFil3('TODOS');
        setFiltersitua(false);
    }

    function ShowFilter() {
        setFiltersitua(!filtersitua);
    }

    
    //Função para gravar dados a serem usados na page detalhes
    function DetalheAssistencia(wseqoco) {
        let temp = [];
        assistencias.filter(assistencia => assistencia.seqoco == wseqoco).map((item) => {
            temp.push({
                seqoco: item.seqoco,
                datoco: item.datoco,
                tipass: item.tipass,
                motass: item.motass,
                status: item.situa,
                datenc: item.datenc,
                page: "/Assistencia"
            })
        })
        setDadosAss(temp);

        Navigate('/DetAssistencia');
    }

    function Filtro(wtipfil, wvalue) {
        if (wvalue.length == 0 && wtipfil != 3) {
            setTipfil('2')
        } else {


            if (wtipfil == '1') {
                setTipfil('1');
                //setFil1(wvalue);
            }
            if (wtipfil == '2') {
                setFil1('');
                setFil2(wvalue);
                setTipfil('2');
                //setFil2(wvalue);
            }
            if (wtipfil == '3') {
                setFil1('');
                setFil3(wvalue);
                setTipfil('3');

            }
        }
    }
    
    
    
    
    async function GetAssistencias() {
        let temp = [];
        let data = [];
        let datafim = [];


        await api.get(`assistencias/lista?cgccli=${cgccli}&tipfil=${tipfil}&fil1=${fil1}&fil2=${fil2}&fil3=${fil3}`)
            .then((response) => {
                if (!response.data.msg) {
                    
                    temp = response.data;
                    temp.map((item) => {
                        if (data.indexOf(item.datoco) < 0) {
                            data.push(
                                item.datoco
                            )
                        }
                    })

                    data.map((item) => {
                        datafim.push({
                            datoco: item
                        })
                    })

                    setDatas(datafim);
                    SetAssistencias(response.data);
                    setCurrentPage(0);
                    setLoading(false);
                } else {

                }
            }).catch((erro) => {

            })
    }


    useEffect(() => {
        GetAssistencias();
    }, [tipfil,fil2,fil3])


    return (
        <>
            <div className={styled.diviconfilter} onClick={() => ShowFilter()}>
                <CiFilter size={28} />
                <span>Filtros</span>
            </div>

            {(filtersitua == true) || (window.screen.availWidth >= 1024) ?
                <div className={styled.divfiltros}>
                    <div className={styled.divfiltro1}>
                        <a>Nº ASSISTÊNCIA</a>
                        <div className={styled.input}>
                            <input type='text' placeholder='Pesquisar' value={fil1} onChange={(e) => setFil1(e.target.value)} />
                            <CiSearch onClick={() => Filtro('1', fil1)} className={styled.divfiltro1icon} />
                        </div>
                    </div>

                    <div className={styled.divfiltro1}>
                        <a>EXIBIR ASSISTÊNCIAS DE</a>
                        <div className={styled.select}>
                            <select name="data" id="data" onChange={(e) => Filtro('2', e.target.value)} >
                                <option value="0">Até 1 ano atrás</option>
                                <option value="1">Até 2 anos atrás</option>
                                <option value="2">Até 3 anos atrás</option>
                            </select>
                        </div>
                    </div>

                    <div className={styled.divfiltro1}>
                        <a>STATUS DA ASSISTÊNCIA</a>
                        <div className={styled.select}>
                            <select name="data" id="data" onChange={(e) => Filtro('3', e.target.value)}>
                                <option value="TODOS">Todos</option>
                                <option value="PENDENTE">Pendente</option>
                                <option value="PRODUZINDO">Produzindo</option>
                                <option value="EM TRANSPORTE">Em Transporte</option>
                                <option value="ENTREGUE">Entregue</option>
                            </select>
                        </div>
                    </div>
                    <div className={styled.divfiltro2}>
                        <div onClick={() => Limpar()} className={styled.btnlimpa}>
                            Limpar Filtros
                        </div>
                    </div>
                </div> : null}

            <div className={styled.appultimospedidos}>
                <div className={styled.frame99}>
                    {isLoading == true ? <Loader /> : <>
                        {
                            currentItens.map((dat) => {

                                return (
                                    <>
                                        <div className={styled.appitem}>
                                            <a>Aberto em <span>{dat.datoco}</span></a>
                                            <div className={styled.appitemgrupo}>
                                                {assistencias.filter(assistencia => assistencia.datoco == dat.datoco).map((item) => {
                                                    return (
                                                        <div key={item.seqoco} onClick={() => DetalheAssistencia(item.seqoco)} className={styled.appitempedido}>

                                                            <div className={styled.pedidocontent}>
                                                                <div className={styled.pedidocontent0}>
                                                                    <a>Nº <span>{item.seqoco}</span></a>
                                                                    
                                                                    
                                                                </div>
                                                                <div className={styled.pedidocontent1}>
                                                                    
                                                                    <div className={styled.statusdiv}>
                                                                        <div className={styled.tagstatus}>
                                                                            {item.situa == 'EM TRANSPORTE' ? <div className={styled.statustrans}></div> : null}
                                                                            {item.situa == 'PRODUZINDO' ? <div className={styled.statusprod}></div> : null}
                                                                            {item.situa == 'ENTREGUE' ? <div className={styled.statusentregue}></div> : null}
                                                                            {item.situa == 'PENDENTE' ? <div className={styled.statusanalise}></div> : null}
                                                                            <a>{item.situa}</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}

                                            </div>
                                        </div>

                                    </>
                                )
                            })
                        }
                    </>
                    }
                    < div className={styled.paginate}>
                        <Pagination
                            breakLabel="..."
                            nextLabel=">>"
                            onPageChange={PageClick}
                            pageCount={pages}
                            previousLabel="<<"
                            renderOnZeroPageCount={null}
                            containerClassName={'pagination'}
                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            previousClassName={'page-item'}
                            previousLinkClassName={'page-link'}
                            nextClassName={'page-item'}
                            nextLinkClassName={'page-link'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link'}
                            activeClassName={'active'}
                            forcePage={currentPage}
                        />
                    </div>



                </div>

            </div>
        </>
    )

}


export default Listaassistencias;